const zh_CN = {
  title: '快捷视图',
  list: {
    title: '快捷视图列表',
    public: '公开',
    export: '导出配置',
    add_title: '新建快捷视图',
    edit_title: '编辑快捷视图',
    import_title: '导入快捷视图',
    export_title: '导出配置',
    name: '视图名称',
    isPublic: '是否公开',
    filters: '前置过滤条件',
    dynamicLabels: '动态过滤标签',
    dimensionLabels: '展开维度标签',
    preview: '预览',
    count: '数量',
    sample: '样例',
    import_label: '配置 JSON',
    copy: '复制 JSON 内容到剪贴板',
    allSelect: '全选',
    clear: '清空已选的值',
  },
  metrics: {
    title: '监控指标',
    search_placeholder: '搜索，空格分隔多个关键字',
    clear: '清空图表',
    noData: '暂无指标数据，请选择左侧 Labels',
  },
  graph: {
    function: '计算函数',
    none: '无',
    offset: '环比',
    aggregation: '聚合函数',
    aggregation_by: '聚合维度',
    calc: '取值计算',
  },
};
export default zh_CN;
